import * as React from "react";
import {ITransactionsSearchFormOutputData} from "../../../../config/search";
import {useGlobalStores} from "../../../../hooks/use_global_stores";
import {observer} from "mobx-react";
import {TimePeriodFilter} from "./Filters/TimePeriodFilter/TimePeriodFilter";
import {FreeTextField} from "../../../Components/Form/FreeTextField";
import {CheckboxField} from "../../../Components/Form/CheckboxField";
import {ExcludeTransactionsFilter} from "./Filters/ExcludeTransactionsFilter";
import {PaymentMethodFilter} from "./Filters/PaymentMethodFilter";
import { Form } from "../../../Components/Form/Form/Form";
import { useForm } from "../../../../hooks/use_form_v2";

interface ITransactionsSearchFormProps {
    onSubmit(query: ITransactionsSearchFormOutputData): void;
}

export const SearchTransactionsForm = observer(({onSubmit}: ITransactionsSearchFormProps) => {
    const { searchStore } = useGlobalStores();

    const form = useForm<ITransactionsSearchFormOutputData>(searchStore.queryFormData);
    const { register } = form;

    const handleSubmit = (values: ITransactionsSearchFormOutputData) => {
        onSubmit(values);
        return Promise.resolve();
    };

    return (
        <Form form={form} onSubmit={handleSubmit} submitButtonProps={{label: 'Search'}}>
            <Form.Field type={TimePeriodFilter} form={form} />

            <Form.Field type={FreeTextField} {...register('query')} />

            <Form.ContainerField>
                <Form.Field type={CheckboxField} {...register('excludeWithdrawals')} noWrapper />
                <Form.Field type={CheckboxField} {...register('excludeWeekdaysLunch')} noWrapper />
            </Form.ContainerField>

            <Form.Field type={ExcludeTransactionsFilter} {...register('excludedTransactions')} />
            <Form.Field type={PaymentMethodFilter} {...register('includePaymentMethods')} />
        </Form>
    );
});
